import { createRouter, createWebHistory  } from "vue-router";
import LKPage from "../pages/LKPage.vue";
import Login from "../pages/LoginPage.vue";
import UnderConstructionPage from "../pages/UnderConstructionPage.vue";
import { mainStorage } from "@/composables/tools/main-storage.tools";
import {goLkPage, goMainPage} from "@/composables/ModuleCommunication";
import { useStore } from "@/store";
import {useProjects} from "@/store/projects";
import {projectDisabledModules} from "@/composables/constans/modules";
import LKProfileWindow from "@/pages/LKPage/LKWindow/LKProfileWindow.vue";
import LKProjectWindow from "@/pages/LKPage/LKWindow/LKProjectWindow.vue";

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/lk",
    name: "lk",
    component: LKPage,
    redirect: "/lk/projects",
    children: [
      {
        path: "profile",
        name: "profile",
        component: LKProfileWindow
      },
      {
        path: "projects",
        name: "projects",
        component: LKProjectWindow,
        // Модальные окна создания/редактирования проекта
        children: [
          {
            path: "new",
            name: "project-new",
            component: { template: "<div></div>" },
            meta: { modal: true, isEdit: false }
          },
          {
            path: "edit/:projectId",
            name: "project-edit",
            component: { template: "<div></div>" },
            meta: { modal: true, isEdit: true }
          }
        ]
      },
      {
        path: "archive",
        name: "archive",
        component: LKProjectWindow
      },
    ]
  },
  {
    path: "/under-construction",
    name: "under-construction",
    component: UnderConstructionPage,
    props: true,
  },
];

const history = createWebHistory();

const router = createRouter({
  history: history,
  routes
});

router.beforeEach(async (to, from, next) => {
  const store = useStore();

  if (to.name === "login") {
    if (mainStorage.getItem("access_token")) {
      goMainPage();
    }
  }

  if (!mainStorage.getItem("access_token")) {
    if (to.name !== "login" && to.name !== "under-construction") {
      await router.push("login");
    }
  } else if (to.name === "login") {
    goMainPage();
  }
  else if(to.fullPath === "/" && store.mainHrefApp){
    goMainPage();
    document.body.style.backgroundColor = "#EEF1F4";
  } else if (to.path.startsWith("/lk")){
    document.body.style.backgroundColor = "#EEF1F4";
  } else {
    document.body.style.backgroundColor = "#EEF1F4";
  }

  const projectStore = useProjects();

  if (projectStore.activeProject?.modules?.length > 0
      && !projectStore.activeProject?.modules.includes(store.activeModule.dataName)
      && !projectDisabledModules.includes(store.activeModule.dataName)) {
    if (to.name !== "lk") {
      await ProjectHasntModule();
    }
  } else {
    if (window.routerApp && !to.path.startsWith("/lk")) {
      window.routerApp.replace(to);
    }
  }
  next();
});

/** Редирект, если у пользователя отсутствуют проекты */
export const userHasntProjects = async () => {
  const store = useStore();
  store.createNotify("Создайте проект, чтобы начать использовать систему", "error");
  await goLkPage();
};


/** Редирект, если у активного проекта нет модуля, в котором сейчас находится пользователь. */
export const ProjectHasntModule = async () => {
  const store = useStore();

  await goLkPage();
  store.isShowProjectNoModuleDialog = true;
};

window.routerLK = router; 
export default router;
